import { useEffect, useRef } from 'react';
import { toast } from 'sonner';

const IDLE_MS = 30 * 60 * 1000;
const WARN_MS = 29 * 60 * 1000;
const CHECK_INTERVAL_MS = 15_000;

const ACTIVITY_EVENTS = ['mousedown', 'keydown', 'scroll', 'touchstart'] as const;

export function useInactivityLogout(onIdle: () => void): void {
    const onIdleRef = useRef(onIdle);

    useEffect(() => {
        onIdleRef.current = onIdle;
    }, [onIdle]);

    useEffect(() => {
        let lastActivity = Date.now();
        let warned = false;

        const reset = () => {
            lastActivity = Date.now();
            warned = false;
        };

        for (const event of ACTIVITY_EVENTS) {
            window.addEventListener(event, reset, { passive: true });
        }

        const interval = window.setInterval(() => {
            const elapsed = Date.now() - lastActivity;
            if (elapsed >= IDLE_MS) {
                onIdleRef.current();
                return;
            }
            if (!warned && elapsed >= WARN_MS) {
                warned = true;
                toast.warning(
                    'Session will expire in 1 minute due to inactivity. Click anywhere to stay signed in.',
                    { duration: 60_000 },
                );
            }
        }, CHECK_INTERVAL_MS);

        return () => {
            for (const event of ACTIVITY_EVENTS) {
                window.removeEventListener(event, reset);
            }
            window.clearInterval(interval);
        };
    }, []);
}
